import {createDialogLazy} from "@/utils/helpers-external";
import contentInputProcessor from "@/tools/GenogramTool/lib/ContentInputProcessor";

let GenogramExportDialog = () => import("@/tools/GenogramTool/dialogs/GenogramExportDialog.vue");
let genogramExportDialog = createDialogLazy(GenogramExportDialog)

class GenogramExportCommandBuilder {

	constructor() {
		this.lastOptions = {
			title: "",
			showHandwritingSpace: false,
			preserveViewport: false,
		}
	}

	async parseSeoBlogEmbedGenogram(rawInput) {
		let parsedResult = await contentInputProcessor.process(rawInput)
		this.rememberOptions(parsedResult.meta)
		return parsedResult
	}

	async buildSeoBlogEmbedGenogram(genogramItem) {
		let promptResult = await genogramExportDialog({
			defaultTitle: this.lastOptions.title,
			defaultShowHandwritingSpace: this.lastOptions.showHandwritingSpace === true,
			defaultPreserveViewport: this.lastOptions.preserveViewport === true,
		})

		if (!promptResult) {
			return null
		}

		this.rememberOptions(promptResult)
		return contentInputProcessor.buildGenogramCommand(genogramItem, this.lastOptions)
	}

	rememberOptions(options = {}) {
		this.lastOptions = {
			title: options.title || "",
			showHandwritingSpace: options.showHandwritingSpace === true,
			preserveViewport: options.preserveViewport === true,
		}
	}
}

const genogramExportCommandBuilder = new GenogramExportCommandBuilder()

export default genogramExportCommandBuilder
export {
	GenogramExportCommandBuilder,
}
